export default{
    banner: {
        list: '/api/banner.do',
        main: '/api/main/banner.do'
    },
    // 게시판
    article: {
        // GET
        /**
         * 리스트 조회 시 {boardNo}
         * 상세 조회 시 {boardNo}/{articleNo}
         */
        list: '/api/article/',
        delete: '/api/article/',
        view: '/api/article/',
        newsList: '/api/article/newsList',
        /**
         * 게시판 정보 조회 시 {boardId}.do
         */
        board: '/api/board/',
        main: '/api/mainBoardList.do',
        // POST
        insert: '/api/article/',
    },
    // 컨텐츠
    content: {
        // GET
        menuNo: '/api/content.do',
        cntntmstNo: '/api/content/cntntmstNo.do'
    },
    member: {
        // GET
        dupId: '/api/user/checkDuplicate.do',
        dupEmail: '/api/user/checkDuplicateEmail.do',
        parentCheck: '/api/user/api/member/parentCheck.do',
        logout: '/api/member/logout.do',
        info: '/api/info.do',
        findId: '/api/user/findId.do',
        findPassword: '/api/user/findPassword.do',
        encData: '/api/user/getEncData.do',
        // POST
        regist: '/api/user/registerReg.do',
        login: '/api/member/login.do',
        pwChange: '/api/user/pwChange.do',
        updateMember: '/api/user/updateMember.do',
        nameCheck: '/api/user/niceRealnameAjax.do', // 실명인증
        checkSuccess: '/api/user/checkSuccess.do',
        checkSuccessId: '/api/user/checkSuccessId.do', // 회원가입 보호자 본인인증
        reAgree: '/member/reAgree.do', // 휴면계정 활성화
    },
    department: {
        list: '/api/department.do',
        view: '/api/department/info.do'
    },
    doctor: {
        doctorList: '/api/doctorApi.do',
        deptDoctorList: '/api/doctorApi/deptDoctorList.do',
        schedule: '/api/getDoctorSchedule.do',
        doctorCons: '/api/doctor/consonantList.do',
        record: '/api/getDoctorRecordList.do',
        getDate: '/api/doctorApi/getDoctorReserveDate.do',
        scheduleInfo: '/api/scheduleInfo.do'
    },
    appointment: {
        time: '/api/getDoctorTime.do',
        doctorDayTime: '/api/getDoctorDayTime.do',
        doctorList: '/api/getDoctorList.do',
        reservation: '/api/reservation/reserve.do',
        reservationChange: '/api/reservation/reserveChange.do',
        simpleReservation: '/api/reservation/simpleReservation.do',
        simpleReservationDept: '/api/reservation/simpleReservationDept.do',
        simpleReservationTalk: '/api/reservation/simpleReservationTalk.do',
        getPatInfo: '/api/reservation/getPatInfo.do',
    },
    mypage: {
        reservationList: '/api/mypage/reservation/list.do',
        reservationCancel: '/api/mypage/reservation/cancel.do',
        mainInfo: '/api/mypage/main.do',
        articleList: '/api/mypage/write/list.do',
        articleView: '/api/mypage/write/view.do',
        articleUpdate: '/api/mypage/write/modify.do',
        healthList : '/api/mypage/health/list.do',
        healthReg : '/api/mypage/health/register.do',
        headNoteNewOne : '/api/memberBrainNoteNewOne.do',
        headNote : '/api/memberBrainNote.do',
        headNoteList : '/api/memberBrainNoteList.do',
        headNoteReg : '/api/memberBrainNoteInsert.do',
        headNoteUpdate : '/api/memberBrainNoteUpdate.do',
        headNoteDelete : '/api/memberBrainNoteDelete.do',
        drugList : '/api/drugList.do',
        drugDetail : '/api/drugDetail.do',
        outList : '/api/out.do',
        checkList : '/api/healthCheckResult.do',
        checkDetail : '/api/healthCheckDetail.do',
        healthDel : '/api/mypage/health/delete.do',
        myInfoUpdate : '/api/mypage/info/modify.do',
        myInfoDelete : '/api/mypage/info/withdraw.do',
        passwordCheck: '/api/mypage/info/check.do',
        inspectList: '/api/inspectionReservation.do',
        familyList : '/api/mypage/babyNote/list.do',
        familyReg : '/api/mypage/babyNote/register.do',
        familyMod : '/api/mypage/babyNote/modify.do',
        familyDel : '/api/mypage/babyNote/delete.do',
        diaryList : '/api/mypage/babyDiary/list.do',
        diaryDetail : '/api/mypage/babyDiary/detail.do',
        diaryReg : '/api/mypage/babyDiary/register.do',
        diaryUpdate : '/api/mypage/babyDiary/update.do',
        diaryDel : '/api/mypage/babyDiary/delete.do',
        recordList : '/api/mypage/babyRecord/list.do',
        recordDetail : '/api/mypage/babyRecord/detail.do',
        recordReg : '/api/mypage/babyRecord/register.do',
        recordUpdate : '/api/mypage/babyRecord/update.do',
        recordDel : '/api/mypage/babyRecord/delete.do',
    },
    favorite: {
        add: '/api/favoInfo/favoInfoAddData.do',
        delete: '/api/favoInfo/favoInfoDelData.do',
        list : '/api/mypage/bookmark/data.do',
    },
    search: {
        aortaSearch: '/api/aortaSearch.do',
        brainSearch: '/api/brainSearch.do',
        mombabySearch: '/api/mombabySearch.do',
        bloodSearch: '/api/bloodSearch.do',
        hashKeywords: '/api/getSearchHashKeywords.do',
    },
    lookAround: {
        lookAroundList: '/api/lookAroundList.do',
        lookAround: '/api/lookAround.do',
        deptLookAround: '/api/department/location.do',
        pinList: '/api/navigate/getPinList.do'
    },
    babyNote: {
        list: '/api/momBaby/rsvList.do',
        detail: '/api/momBaby/exmValue.do',
        nextDt: '/api/momBaby/nextRsvDt.do',
        list2: '/api/momBaby/withWeightList.do',
        graph: '/api/momBaby/graph.do'
    },
    glb: {
        reservation: '/api/glb/reservation.do',
        health: '/api/glb/healthPromotionDoctorList.do',
    }
}